import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import {
  makeStyles,
  Grid,
  Divider,
  Typography
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  imageContainer: {
    display: 'flex',
    height: '260px',
    justifyContent: 'center',
    overflow: 'hidden',
    '& img': {
      display: 'block'
    }
  },
  item: {
    maxWidth: '366px'
  },
  title: {
    fontFamily: theme.brandFont,
    fontWeight: 700,
    fontSize: '18px',
    letterSpacing: '1.5px',
    marginTop: theme.spacing(3)
  },
  link: {
    color: theme.palette.text.primary,
    textDecoration: 'none'
  },
  changed: {
    color: theme.palette.primary[900]
  }
}));

const ItemFamilyGrid = (props) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={classes.grid}>
      <Grid container spacing={4}>
        {props.items.map((item) => (
          <Grid item xs={12} sm={6} md={4} className={classes.item} key={item.code}>
            <Link to={item.link} className={classes.link}>
              <div className={classes.imageContainer}>
                {item.imageMain ? <img src={item.imageMain.medium} alt="" /> : null}
              </div>
              <Divider />
              <Typography component="h2" className={classes.title}>{item.name}</Typography>
              <Typography variant="overline" display="block">{item.code}</Typography>
              <Typography variant="overline" display="block">{t('itemFamily:lastChanged')}</Typography>
              <Typography variant="caption" className={classes.changed}>{item.updated}</Typography>
            </Link>
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

ItemFamilyGrid.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object)
}

export default ItemFamilyGrid;
